var exports = {
  "vm": "x28a7bf27--f8d13b--digits",
  "qr": "x28a7bf27--f8d13b--footer",
  "y$": "x28a7bf27--f8d13b--send-button",
  "z3": "x28a7bf27--f8d13b--error",
};

module.exports = exports;
